/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { SavingsContract } from "../SavingsContract";

export class SavingsContract__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _nexus: string,
    _underlying: string,
    overrides?: Overrides
  ): Promise<SavingsContract> {
    return super.deploy(
      _nexus,
      _underlying,
      overrides || {}
    ) as Promise<SavingsContract>;
  }
  getDeployTransaction(
    _nexus: string,
    _underlying: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(_nexus, _underlying, overrides || {});
  }
  attach(address: string): SavingsContract {
    return super.attach(address) as SavingsContract;
  }
  connect(signer: Signer): SavingsContract__factory {
    return super.connect(signer) as SavingsContract__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SavingsContract {
    return new Contract(address, _abi, signerOrProvider) as SavingsContract;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_nexus",
        type: "address",
      },
      {
        internalType: "address",
        name: "_underlying",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "automationEnabled",
        type: "bool",
      },
    ],
    name: "AutomaticInterestCollectionSwitched",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "connector",
        type: "address",
      },
    ],
    name: "ConnectorUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "redeemer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "creditsRedeemed",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "savingsCredited",
        type: "uint256",
      },
    ],
    name: "CreditsRedeemed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "EmergencyUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "newExchangeRate",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "interestCollected",
        type: "uint256",
      },
    ],
    name: "ExchangeRateUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "fraction",
        type: "uint256",
      },
    ],
    name: "FractionUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "oldBalance",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "newBalance",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "interestDetected",
        type: "uint256",
      },
    ],
    name: "Poked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [],
    name: "PokedRaw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "poker",
        type: "address",
      },
    ],
    name: "PokerUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "saver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "savingsDeposited",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "creditsIssued",
        type: "uint256",
      },
    ],
    name: "SavingsDeposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_enabled",
        type: "bool",
      },
    ],
    name: "automateInterestCollectionFlag",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "balanceOfUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "balance",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "connector",
    outputs: [
      {
        internalType: "contract IConnector",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_user",
        type: "address",
      },
    ],
    name: "creditBalances",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_credits",
        type: "uint256",
      },
    ],
    name: "creditsToUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "depositInterest",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_underlying",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_beneficiary",
        type: "address",
      },
    ],
    name: "depositSavings",
    outputs: [
      {
        internalType: "uint256",
        name: "creditsIssued",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_underlying",
        type: "uint256",
      },
    ],
    name: "depositSavings",
    outputs: [
      {
        internalType: "uint256",
        name: "creditsIssued",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_withdrawAmount",
        type: "uint256",
      },
    ],
    name: "emergencyWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "exchangeRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "fraction",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_poker",
        type: "address",
      },
      {
        internalType: "string",
        name: "_nameArg",
        type: "string",
      },
      {
        internalType: "string",
        name: "_symbolArg",
        type: "string",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lastBalance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lastPoke",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nexus",
    outputs: [
      {
        internalType: "contract INexus",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "poke",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "poker",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_underlying",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_beneficiary",
        type: "address",
      },
    ],
    name: "preDeposit",
    outputs: [
      {
        internalType: "uint256",
        name: "creditsIssued",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_credits",
        type: "uint256",
      },
    ],
    name: "redeem",
    outputs: [
      {
        internalType: "uint256",
        name: "massetReturned",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_credits",
        type: "uint256",
      },
    ],
    name: "redeemCredits",
    outputs: [
      {
        internalType: "uint256",
        name: "massetReturned",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_underlying",
        type: "uint256",
      },
    ],
    name: "redeemUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "creditsBurned",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newConnector",
        type: "address",
      },
    ],
    name: "setConnector",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_fraction",
        type: "uint256",
      },
    ],
    name: "setFraction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newPoker",
        type: "address",
      },
    ],
    name: "setPoker",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "underlying",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_underlying",
        type: "uint256",
      },
    ],
    name: "underlyingToCredits",
    outputs: [
      {
        internalType: "uint256",
        name: "credits",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
